import { useMoment } from "@/hooks";

// datetime字符串转只要时分部分
export function fDatetime2Time(datetime: string): string {
    return useMoment(datetime, 'YYYY-MM-DD HH:mm:ss').format("HH点mm分")
}

// datetime字符串转成从"至今字符串"
export function fDatetime2FromNowStr(datetime: string): string {
    return useMoment(datetime, 'YYYY-MM-DD HH:mm:ss').fromNow()
}